import { Modal } from "@/components/elements/Modal";
import { Box, Stack, Typography } from "@mui/material";
import { FCC } from "@/types/common";
import { text } from "@/theme/colors";
import { truncateWithEllipsis } from "@/utils/string";

type TTalentCannotDeleteModalProps = {
  open: boolean;
  onClose: () => void;
  talentNames: string[];
};

export const TalentCannotDeleteModal: FCC<TTalentCannotDeleteModalProps> = ({ open, onClose, talentNames }) => {
  return (
    <Modal isOpen={open} onClose={onClose} labelClose="閉じる" width={500} enableFooter={true} hiddenOkBtn={true} justifyBtnAction="center">
      <Box mb={2}>
        <Typography variant="body1" sx={{ mb: 2, mt: 1 }}>
          以下の人材は案件にマッチングしているため削除できません。
        </Typography>
        <Stack spacing={1.5} sx={{ maxHeight: "500px", overflow: "auto" }}>
          {talentNames.map((talentName, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: text.primary,
                  lineHeight: 1,
                  flexShrink: 0,
                }}
              >
                ・
              </Typography>
              <Typography variant="body1" title={talentName}>
                {truncateWithEllipsis(talentName, 40)}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};
